import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { AxiosInstance } from "../../axios";
import Buttons from "../../components/buttons/Buttons";
import { Modal, Button, InputGroup, FormControl } from "react-bootstrap";
import Styles from "../../pages/joinouteam_view/JoinOurTeam_View.module.css";
import { Arrow_left } from "../../controller/Images";

const JoinOurTeam_View = () => {
  const { jobIdParam } = useParams();
  const navigate = useNavigate();
  const [job, setJob] = useState(null);

  useEffect(() => {
    if (!jobIdParam) return;

    AxiosInstance.post("/api/joinourteam/job/view", { job_id: jobIdParam })
      .then((res) => {
        setJob(res.data?.job);
      })
      .catch((err) => {
        console.error("Fetch error:", err);
      });
  }, [jobIdParam]);

  const [showShareModal, setShowShareModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareLink = jobIdParam
    ? `${window.location.origin}/api/api/joinourteam/${jobIdParam}`
    : "";

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
  };

  // ✅ Pass job_id in URL and job role in state
  const handleApplyJobClick = () => {
    if (!job) return;
    navigate(`/${job.job_id}/apply`, {
      state: {
        jobId: job.job_id,
        role: job.role,
      },
    });
  };

  if (!job) {
    return (
      <div className="container-fluid my-4 text-center">
        {/* <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div> */}
      </div>
    );
  }

  const {
    role,
    job_id,
    yearof_experience,
    work_arrangement,
    department_name,
    location,
    posted_date,
    tag_name,
    description,
  } = job;

  const workArrangementText =
    work_arrangement === "1"
      ? "Onsite"
      : work_arrangement === "2"
        ? "Remote"
        : "Hybrid";

  const formattedDate = new Date(posted_date).toLocaleDateString("en-GB");
  const skills = tag_name?.split(",").join(", ") || "N/A";

  return (
    <div className="container-fluid p-0">
      <div className="card shadow">
        <div style={{ backgroundColor: "var(--color--grey)" }}>
          <div className={`${Styles.responsivepadding}`}>
            {/* Header */}
            {/* Header */}
            <div className="main_heading p-3 d-flex justify-content-between flex-column flex-lg-row align-items-start align-items-lg-center gap-3">
              {/* Left Section: Back Arrow + Role */}
              <div
                className={`d-flex align-items-center gap-3 ${Styles.job_heading}`}
              >
                {/* Back Arrow Image */}
                <img
                  src={Arrow_left}
                  alt="Back"
                  onClick={() => navigate("/join-our-team")}
                  title="Back to Job List"
                  style={{
                    width: "40px",
                    height: "40px",
                    cursor: "pointer",
                    objectFit: "contain",
                  }}
                />
                {/* Role Text */}
                <h5 className={`my-0 main_heading ${Styles.job_heading}`}>
                  {role}
                </h5>
              </div>

              {/* Right Section: Share + Apply Button */}
              <div className="d-flex align-items-center gap-3">
                {/* Share Icon */}
                <i
                  className="bi bi-share-fill"
                  style={{
                    fontSize: "20px",
                    cursor: "pointer",
                    color: "var( --blue-color)",
                  }}
                  title="Share this job"
                  onClick={() => setShowShareModal(true)}
                />

                {/* Apply Button */}
                <Buttons
                  text="Apply for this job"
                  type="button"
                  variant="outline-secondary"
                  size="sm"
                  onClick={handleApplyJobClick}
                />
              </div>
            </div>

            {/* Share Modal */}
            <Modal
              show={showShareModal}
              onHide={() => setShowShareModal(false)}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Share This Job</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <InputGroup className="mb-2">
                  <FormControl value={shareLink} readOnly />
                  <Button variant="outline-secondary" onClick={handleCopy}>
                    <i className="bi bi-clipboard"></i>
                  </Button>
                </InputGroup>
                {copied && (
                  <div className="text-success small">
                    Link copied to clipboard!
                  </div>
                )}
              </Modal.Body>
            </Modal>

            {/* Job Info Row */}
            <div className="row mb-3 p-3">
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Job ID</div>
                <p className="main_paragraph">{job_id}</p>
              </div>
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Min Years of Experience</div>
                <p className="main_paragraph">{yearof_experience}</p>
              </div>
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Work Arrangement</div>
                <p className="main_paragraph">{workArrangementText}</p>
              </div>
            </div>

            <div className="row mb-3 p-3">
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Department</div>
                <p className="main_paragraph">{department_name}</p>
              </div>
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Location</div>
                <p className="main_paragraph">{location}</p>
              </div>
              <div className="col-12 col-md-4 mb-3 mb-md-0">
                <div className="form-label mb-2">Posted On</div>
                <p className="main_paragraph">{formattedDate}</p>
              </div>
            </div>

            {/* Skills Section */}
            <div className="mb-4 p-3">
              <div className="form-label mb-2">Skills Set</div>
              <p className="main_paragraph">{skills}</p>
            </div>
          </div>
        </div>

        {/* Job Description */}
        <div className={`py-4 ${Styles.responsivepadding}`}>
          <h6 className="form-label px-3">Job Description</h6>
          <p className="main_paragraph px-3" style={{ whiteSpace: "pre-line" }}>
            {description || "No detailed description available."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default JoinOurTeam_View;
